export default __webpack_public_path__ + "static/media/icon-minus-blue.267131ec.svg";